import React from "react";
import { FileText } from "lucide-react";

// Small "N docs" badge for project rows (reconstructed — source not in kit).
export default function DocCountBadge({ count = 0, testId }) {
  return (
    <span
      data-testid={testId}
      className="inline-flex items-center gap-1 rounded-full border border-white/15 bg-[#0a0a0a] px-2 py-0.5 text-xs text-slate-300"
      title={`${count} document${count === 1 ? "" : "s"}`}
    >
      <FileText className="w-3 h-3 text-[#8fa4f0]" />
      {count}
    </span>
  );
}
